import { VideoPlaylistSection } from "@components/Layouts/Home/VideoPlaylistSection";
import VideoPlayer from "@components/Layouts/Player/VideoPlayer";
import { BC_PLAYER_ID, BC_PLAYER_ID_HOME } from "@helper/getEnvVariables";
import { LatestVideoResponse } from "@transformer/useBrightcoveResponse";
import { ReactElement } from "react";

// Achievement Section Component
export const Achievements = ({
  tm90Video,
  tm90VideoPlaylist,
}: {
  tm90Video?: LatestVideoResponse;
  tm90VideoPlaylist?: LatestVideoResponse[];
}): ReactElement => {
  return (
    <div className="bg-grey-100 py-12">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-lg leading-[160%] font-bold text-left mb-6 text-gray-100">
          எங்கள் TM90 கொண்டாட்ட நிகழ்வில் எங்களுடன் சேருங்கள்.
        </h2>

        <div className="bg-white rounded-lg">
          {tm90VideoPlaylist !== undefined ? (
            <VideoPlaylistSection
              playerId={BC_PLAYER_ID_HOME}
              bcVideos={tm90VideoPlaylist}
              tm90Override={true}
            />
          ) : (
            tm90Video?.id && (
              <VideoPlayer
                playing={tm90Video}
                headerType="h1"
                showTitle={false}
                playerId={BC_PLAYER_ID}
                showShare={false}
                showDate={false}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};
